const path = require('path')

module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF

    return {
        test: /\.ts(x?)$/,
        loader: `${ FURTHER_REF }babel-loader?presets[]=${ FURTHER_REF }babel-preset-es2015!${ FURTHER_REF }ts-loader?` + JSON.stringify({
            configFile: path.resolve(FURTHER_REF, '../', '.meta/tsconfig.json')
        }),
        exclude: /node_modules/
    }
}



// WEBPACK FOOTER //
// ./src/technologies/type-script.js